import { render, staticRenderFns } from "./info-link.vue?vue&type=template&id=5bc2eb26"
import script from "./info-link.vue?vue&type=script&lang=js"
export * from "./info-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports